// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
    box-sizing: border-box;
}

.HeroSectionWholeOrg {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 80vh;  /* Set a minimum height to prevent content from being too cramped */
    /* background-color: rgb(114, 158, 114); */
    background-color: #003300;
    background-size: cover;
    overflow: hidden;
}

.HeroContent {
    display: grid;
    grid-template-columns: 1fr;
    margin-right: 30px;
    color: white;
    padding: 0 15px; /* Adjust padding for smaller screens */
    margin-top: 20px;
    gap: 20px;
}

.HeroSectionWholeOrg .video {
    width: 100%;
    overflow: hidden;
}

.HeroSectionWholeOrg .video img {
    width: 100%;
    height: auto;
    object-fit: cover;
}

.wording {
    padding-top: 20px; /* Adjust padding for smaller screens */
}

.wording button {
    width: 100%;
    max-width: 250px;
    height: 3rem;
    font-size: 1rem;
    cursor: pointer;
    color: #003300;
    font-weight: 500;
}

@media screen and (min-width: 731px) {
    .HeroContent {
        grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    }
}




/* 
*{
    box-sizing: border-box;
}

.HeroSectionWholeOrg{
   
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 80vh;
    background-color: #003300;
  
    background-size: cover;
    overflow: hidden;
}
.HeroContent{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(450px,1fr)) ;
    margin-right: 30px;color: white;
    padding-left: 30px;
    margin-top: 20px;
    height: 400px;
    gap: 30px;
     
   
}
.HeroSectionWholeOrg .video{
    
    height: 100%;
    width: 100%;
    overflow: hidden;
  
}
.HeroSectionWholeOrg .video img{
    
    
    height: auto;
    width: 100%;
    overflow: hidden;
    object-fit: cover;
    padding: 0;
    margin: 0;
   
}
.HeroSectionWholeOrg img{
        
   
}

.wording{
    padding-top: 50px;
   
}
.wording button{

    width: 250px;
    height: 3rem;
    font-size: 1rem;
    cursor: pointer;
    color: #003300;
    font-weight: 500;
}

@media screen and (max-width: 730px){   



    .HeroSectionWholeOrg{
        height: auto;
    }

    .HeroContent{
        height: auto;
    }



  
    
    
}




 */
`, "",{"version":3,"sources":["webpack://./src/Components/HeroSectionOrg/HeroSectionOrg.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB,GAAG,mEAAmE;IACtF,0CAA0C;IAC1C,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAE,uCAAuC;IACxD,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB,EAAE,uCAAuC;AAC9D;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,2DAA2D;IAC/D;AACJ;;;;;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsFE","sourcesContent":["\n* {\n    box-sizing: border-box;\n}\n\n.HeroSectionWholeOrg {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 80vh;  /* Set a minimum height to prevent content from being too cramped */\n    /* background-color: rgb(114, 158, 114); */\n    background-color: #003300;\n    background-size: cover;\n    overflow: hidden;\n}\n\n.HeroContent {\n    display: grid;\n    grid-template-columns: 1fr;\n    margin-right: 30px;\n    color: white;\n    padding: 0 15px; /* Adjust padding for smaller screens */\n    margin-top: 20px;\n    gap: 20px;\n}\n\n.HeroSectionWholeOrg .video {\n    width: 100%;\n    overflow: hidden;\n}\n\n.HeroSectionWholeOrg .video img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n}\n\n.wording {\n    padding-top: 20px; /* Adjust padding for smaller screens */\n}\n\n.wording button {\n    width: 100%;\n    max-width: 250px;\n    height: 3rem;\n    font-size: 1rem;\n    cursor: pointer;\n    color: #003300;\n    font-weight: 500;\n}\n\n@media screen and (min-width: 731px) {\n    .HeroContent {\n        grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n    }\n}\n\n\n\n\n/* \n*{\n    box-sizing: border-box;\n}\n\n.HeroSectionWholeOrg{\n   \n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 80vh;\n    background-color: #003300;\n  \n    background-size: cover;\n    overflow: hidden;\n}\n.HeroContent{\n    display: grid;\n    grid-template-columns: repeat(auto-fit,minmax(450px,1fr)) ;\n    margin-right: 30px;color: white;\n    padding-left: 30px;\n    margin-top: 20px;\n    height: 400px;\n    gap: 30px;\n     \n   \n}\n.HeroSectionWholeOrg .video{\n    \n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n  \n}\n.HeroSectionWholeOrg .video img{\n    \n    \n    height: auto;\n    width: 100%;\n    overflow: hidden;\n    object-fit: cover;\n    padding: 0;\n    margin: 0;\n   \n}\n.HeroSectionWholeOrg img{\n        \n   \n}\n\n.wording{\n    padding-top: 50px;\n   \n}\n.wording button{\n\n    width: 250px;\n    height: 3rem;\n    font-size: 1rem;\n    cursor: pointer;\n    color: #003300;\n    font-weight: 500;\n}\n\n@media screen and (max-width: 730px){   \n\n\n\n    .HeroSectionWholeOrg{\n        height: auto;\n    }\n\n    .HeroContent{\n        height: auto;\n    }\n\n\n\n  \n    \n    \n}\n\n\n\n\n */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
